import { AnySchema } from 'ajv';
import { t } from 'i18next';

import { FieldErrorMessage } from '../../../../../models/FieldErrorMessage';
import { validateFormData } from '../../../../../utils/validations/validateFormData';
import { SRSubscriptionPricingFormFields } from './srSubscriptionPricingForm.models';

interface IValidateSubscriptionPricingForm {
  membershipPlans: any[];
}

export const srSubscriptionPricingSchema: AnySchema | any = {
  properties: {
    [SRSubscriptionPricingFormFields.Pricing]: {
      errorMessage: t('api-validation.AtLeastOnePlanMustBeAdded'),
      type: 'object',
    },
  },
  required: [],
  type: 'object',
};

export const validateSubscriptionPricingForm = (
  data: IValidateSubscriptionPricingForm,
  additionalErrors?: FieldErrorMessage[],
) => validateFormData(data, additionalErrors, srSubscriptionPricingSchema);
